import React from "react";
import { motion } from "framer-motion";
import { HOW_IT_WORKS } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid={HOW_IT_WORKS.section}
      className="relative py-28 md:py-44 bg-[#FDFBF7] overflow-hidden"
    >
      {/* discreet decorative hairline at the top of the section */}
      <div className="absolute inset-x-0 top-0 h-px bg-[#2C2826]/10" />

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-y-16 md:gap-x-16 lg:gap-x-24 items-center">
          {/* LEFT — copy */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.1, ease }}
            className="col-span-12 md:col-span-6 lg:col-span-5 md:order-1"
          >
            <p className="overline mb-12">— Cum funcționează</p>

            <h2
              data-testid={HOW_IT_WORKS.title}
              className="font-display text-[2.2rem] leading-[1.18] sm:text-4xl md:text-[3.1rem] lg:text-[3.6rem] text-[#2C2826] tracking-[-0.018em]"
            >
              Pulverizezi.
              <span className="block mt-3 md:mt-4">Hidratezi.</span>
              <span className="accent-soft block mt-3 md:mt-4">Pleci.</span>
            </h2>

            <p
              data-testid={HOW_IT_WORKS.body}
              className="mt-6 max-w-md text-base md:text-[1.05rem] leading-[1.85] text-[#5C5652] font-light"
            >
              Hidratare în câteva secunde.
              <span className="block mt-5">
                Un micro-mist inspirat din skincare, creat pentru
                îngrijirea corpului de zi cu zi.
              </span>
            </p>

            <div className="mt-10 w-16 h-px bg-[#2C2826]/30" />
          </motion.div>

          {/* RIGHT — image (spray direction → toward the text on the left) */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.3, ease, delay: 0.1 }}
            className="col-span-12 md:col-span-6 lg:col-span-7 md:order-2"
          >
            <div className="relative">
              {/* subtle warm halo behind the bottle */}
              <div
                aria-hidden
                className="absolute inset-0 -z-10 blur-3xl opacity-60"
                style={{
                  background:
                    "radial-gradient(60% 55% at 70% 50%, #EFE7DA 0%, rgba(239,231,218,0) 70%)",
                }}
              />
              <img
                data-testid={HOW_IT_WORKS.image}
                src="/images/eilea-spray-demo.png"
                alt="EILEA Body Milk Mist — pulverizare ultrafină inspirată din skincare"
                loading="lazy"
                className="block w-full h-auto select-none"
                draggable="false"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
